import { datastore } from '@shared/api'

export interface InlinePopupOption {
	label: string
	value: string
}

async function loadOptions(): Promise<InlinePopupOption[]> {
	if (typeof window === 'undefined' || !window.location.pathname.includes('/_blox_preview')) return []

	try {
		const response = await datastore.collections.get({
			store: 'the_torah',
			collectionName: 'popups',
			limit: 1000,
		})
		const items = Array.isArray(response) ? response : []

		return items
			.filter((item: any) => item.type === 'inline')
			.map((item: any) => ({
				label: item.name || item.slug || 'Untitled inline content',
				value: item.id || item._id || item.slug,
			}))
	} catch (error) {
		console.error('[BlockInlinePopup] Failed to load editor options:', error)
		return []
	}
}

export const inlinePopupOptions = await loadOptions()
